import { useForm as useRHForm, type DefaultValues } from 'react-hook-form';
import { useSyncTanstackToRHF } from './useSyncTanstackToRHF';

// Define a generic record type for form data
type FormDataRecord = Record<string, unknown>;

/**
 * Creates a hybrid form setup with TanStack Form for logic and React Hook Form for shadcn/ui compatibility.
 *
 * @param tanstackForm - The TanStack Form instance
 * @param fieldNames - Array of field names to sync
 * @param defaultValues - Default values for both forms
 * @returns React Hook Form instance for use with FormProvider
 */
export function useHybridForm<
  TFormData extends FormDataRecord = FormDataRecord,
>(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  tanstackForm: any, // Use any for TanStack form to avoid complex type compatibility issues
  fieldNames: (keyof TFormData)[],
  defaultValues: DefaultValues<TFormData>
) {
  const rhfForm = useRHForm({
    defaultValues,
  });

  useSyncTanstackToRHF(tanstackForm, rhfForm, fieldNames);

  return rhfForm;
}
